import setup from "../setup";

/** Checking what translations are missing. */
const checkMissingTranslations = () => {
    const { availableLocales, fallbackLocale, messages } = setup.i18n;
    
    const translations = {};
    availableLocales.forEach(locale => translations[locale] = flattenObj(messages[locale]));

    const notDefaultLocales = availableLocales.filter(locale => locale !== fallbackLocale);
    
    const missing = {};
    notDefaultLocales.forEach(locale => missing[locale] = {});

    Object.entries(translations[fallbackLocale]).forEach(([key, value]) => {
        if (!value) return;
        notDefaultLocales.forEach(locale => {
            if (translations[locale][key]) return;
            missing[locale][key] = value;
        });
    });

    console.log("Missing translations", JSON.stringify(missing));
}

const flattenObj = (ob) => {
  
    // The object which contains the
    // final result
    let result = {};
  
    // loop through the object "ob"
    for (const i in ob) {
  
        // We check the type of the i using
        // typeof() function and recursively
        // call the function again
        if ((typeof ob[i]) === 'object') {
            const temp = flattenObj(ob[i]);
            for (const j in temp) {
  
                // Store temp in result
                result[i + '.' + j] = temp[j];
            }
        }
  
        // Else store ob[i] in result directly
        else {
            result[i] = ob[i];
        }
    }
    return result;
};

export default checkMissingTranslations;